import { HerPartDrivesCrazyCompatibilityOptionsType } from './types';

export const HER_PART_DRIVES_CRAZY_COMPATIBILITY_OPTIONS: HerPartDrivesCrazyCompatibilityOptionsType =
  [
    { id: 'thighs_wrapped', title: 'Her thighs wrapped around you' },
    { id: 'back_arches', title: 'The way her back arches' },
    { id: 'hands_pulling', title: 'Her hands pulling you closer' },
    { id: 'look_in_eyes', title: 'That look in her eyes when she wants more' },
  ];
